// The client's own words, first and largest. This is the part of the old Word
// document planners asked to keep, and it is what makes everything after it
// read as a response rather than as a pitch.
//
// It renders inside the opening card rather than as a card of its own, so the
// first slide of a meeting is the whole opening: who this is for, the three
// numbers, and what they said they wanted. On its own it was a thin slide to
// start a meeting on.
//
// The heading speaks to the client rather than about them. "What Alex and Sam
// told us matters" is how you would describe them to a colleague; the page is
// being read by Alex and Sam.

export default function GoalsSection({ goals }) {
  const lines = String(goals || '')
    .split(/\r?\n/)
    .map(l => l.replace(/^[\s•\-*]+/, '').trim())
    .filter(Boolean);

  if (!lines.length) return null;

  return (
    <div className="asmt-hero-goals">
      <h2>What you told us matters</h2>
      <div className="asmt-goal-list">
        {lines.map((line, i) => (
          <div className="asmt-goal" key={i}>
            <span className="asmt-goal-marker" />
            <span>{line}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
